import {useState} from "react";
import {Button, Form, Modal} from "semantic-ui-react";
import {useAppDispatch} from "../../app/hooks";
import {CreateNewDpiValue} from "./TablesActions";
import { useSelector } from "react-redux";
import { RootState } from "../../app/store";
import { useTranslation } from "react-i18next";
interface IDpiModal {
  open: boolean;
  onClose: () => void;
}
export const DpiModal = ({open, onClose}: IDpiModal) => {
  const {companyId} = useSelector((state: RootState) => state.auth);
  const [dpi, setDpi] = useState<number>();
  const [error, setError] = useState<string>("");
  const dispatch = useAppDispatch();
  const {t} = useTranslation(); 
  const onInputChange = (e: any) => {
    setError("");
    const {value} = e.target;
    setDpi(value);
  };

  const onSubmit = () => {
    if (dpi === undefined || dpi === null) {
      setError(t("dpi_empty_err"));
      return;
    }
    if (!/^\d+$/.test(dpi.toString()) || Number(dpi) <= 0) {
      setError(t("dpi_invalid_err"));
      return;
    }
    dispatch(CreateNewDpiValue(dpi, companyId));
    onHide();
  };
  const onHide = () => {
    setDpi(undefined);
    setError("");
    onClose();
  };
  return (
    <Modal size="small" closeIcon onClose={onHide} open={open}>
      <Modal.Header>{t("create_new_dpi")}</Modal.Header>
      <Modal.Content>
        <Form onSubmit={onSubmit}>
          <Form.Field required>
            <label>{t("dpi")}</label>
            <Form.Input autoFocus placeholder={t("dpi")} required name="dpi" value={dpi || ""} onChange={onInputChange} error={error !== "" ? {content: error, pointing: "below"} : false} />
          </Form.Field>
        </Form>
      </Modal.Content>
      <Modal.Actions>
        <Button color="black" basic onClick={onHide}>
          {t("cancel_btn")}
        </Button>
        <Button color="green" basic type="submit" onClick={onSubmit}>
          {t("create_btn")}
        </Button>
      </Modal.Actions>
    </Modal>
  );
};
